import { render } from "./SliderCheck.vue?vue&type=template&id=21484701&scoped=true"
import script from "./SliderCheck.vue?vue&type=script&lang=js"
export * from "./SliderCheck.vue?vue&type=script&lang=js"

import "./SliderCheck.vue?vue&type=style&index=0&id=21484701&scoped=true&lang=css"

import exportComponent from "E:\\claude\\match\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21484701"]])

export default __exports__